import { MeRequiredField } from "~/components/person/constants";
import { isEmpty } from "~/utils/common";

type MeFields = Record<MeRequiredField, unknown>;

const getEmptyRequiredFields = (me: MeFields): MeRequiredField[] =>
  Object.values(MeRequiredField).filter(fieldName => isEmpty(me[fieldName]));

export default getEmptyRequiredFields;
